import './PrimeInputText.scss';
import { forwardRef } from "react";
import { InputText } from 'primereact/inputtext';

const PrimeInputText = forwardRef((props, ref) => {
  const { className, leftIcon, isTypeInset, rightIcon, ...restProps } = props
  const insetTypeClassName = isTypeInset ? 'InsetType' : ''

  const textField = <InputText ref={ref} className={`PrimeInputText ${insetTypeClassName} ${className}`} {...restProps} />

  if (leftIcon) {

    return (
      <span className={`IconContainer ${insetTypeClassName} p-input-icon-left`}>
        {leftIcon}
        {textField}
      </span>
    )

  }
  
  if (rightIcon) {

    return (
      <span className={`IconContainer ${insetTypeClassName} p-input-icon-right`}>
        {rightIcon}
        {textField}
      </span>
    )

  }

  return textField
})

PrimeInputText.defaultProps = {
  leftIcon: null,
  isTypeInset: false
}

export default PrimeInputText